(function () {
    'use strict';

    angular
        .module('actionPlanModule')
        .controller('grcActionPlanWithDeliverablesListController', Controller);

    Controller.$inject = ['$scope', 'grcActionPlanCriteriaService', 'historyCtxtService'];

    function Controller($scope, grcActionPlanCriteriaService, historyCtxtService) {

        $scope.goToDeliverable = function ($event, item) {
            $event.stopPropagation();
            historyCtxtService.goToState('actionPlanCriteriaEdit',
              {
                  ActionPlanCriteriaID: item.ActionPlanCriteriaID,
                  ActionPlanID: $scope.boxModel.ActionPlanID
              },
              'recommendation.edit.actionPlan.edit',
              $scope.boxModel
            );
        };

        // Get criterias for ActionPlan
        if (!_.isUndefined($scope.boxModel.ActionPlanID)) {
            return grcActionPlanCriteriaService.getActionPlanCriteriasByActionPlan($scope.boxModel.ActionPlanID).then(function (result) {
                $scope.deliverables = result;
            });
        }

    }
})();

